export { default } from "./black-friday-banner";
